module.exports = __webpack_public_path__ + "img/platform_device.e795ba44.png";